import { parse } from 'valibot';
import { type EntityResponse, responseStatusEnum } from '@/shared/types/api';
import type { SearchArticlesPayload, TSearchArticle } from './../types';
import useRequest from '@/shared/composables/use-request';
import { schemeSearchData } from './schemes';

class Search {
	async fetchArticles(payload?: SearchArticlesPayload): EntityResponse<TSearchArticle> {
		try {
			const response = await useRequest().$get('/articles/search/', {
				query: payload,
			});

			if (response.status === responseStatusEnum.error) {
				return response;
			}

			return parse(schemeSearchData, response.data);
		} catch (e) {
			console.error(e);
			throw e;
		}
	}
}

export default new Search();
